$(function () {
    const elements = document.querySelectorAll('.vc-day-content');
    elements.forEach(el => {
        el.addEventListener('touchstart', e => {
            e.preventDefault();
            el.click();
        });
    });

    /**
     * Primary Nav
     */
    // Only toggle menu when hamburger is clicked
    $('.hamburger').on('click', function (e) {
        $('.main-menu').find('.sub-open').removeClass('sub-open');
        $('.main-menu').find('.sub-active').removeClass('sub-active');
        $('.hamburger, .main-menu').toggleClass('is-active');
        $('html').toggleClass('no-scroll');
    });

    // Remove the problematic document click handler
    // if (windowWidth > 767) {
    //     $(document).on('click', function (e) { ... });
    // }

    $('.no-sub').on('click', function (e) {
        e.preventDefault();
    });

    $('.back').on('click', function (e) {
        $('.main-menu').find('.sub-open').removeClass('sub-open');
        $('.main-menu').find('.sub-active').removeClass('sub-active');
    });
});

if ('ontouchstart' in document.documentElement) {
    $('.pri-link').on('click', function (e) {
        $(this).trigger('mouseenter');
        $('.main-menu').find('.sub-open').removeClass('sub-open');
        $('.main-menu').find('.sub-active').removeClass('sub-active');
        if ($(this).closest('.nav-link').hasClass('sub')) {
            $(this).parent('.sub').addClass('sub-open');
            $('.nav-box').addClass('sub-active');
            $('.nav-wrapper').addClass('sub-active');
        }
    });
} else {
    $('.pri-link').on('mouseenter', function (e) {
        $('.main-menu').find('.sub-open').removeClass('sub-open');
        $('.main-menu').find('.sub-active').removeClass('sub-active');
        if ($(this).closest('.nav-link').hasClass('sub')) {
            $(this).parent('.sub').addClass('sub-open');
            $('.nav-box').addClass('sub-active');
            $('.nav-wrapper').addClass('sub-active');
        }
    })
}


/**
 * Signup modal
 */
// Check for cookie
var sup = Cookies.get('signupCookie')
if (sup) {
    $('#signup-sideout').addClass('sideout-blocked')
}
// close
$('#signup-sideout .close').on('click', function (e) {
    $('#signup-sideout').addClass('sideout-hide')
})

$(window).on('scroll', function () {
    var y = $(this).scrollTop();
    if (y > 500) {
        $('#signup-sideout').addClass('sideout-show')
        //$(window).off('scroll');
    }
    if (y > 250) {
        $('body').addClass('window-300')
    } else {
        $('body').removeClass('window-300')
    }
});

/**
 * Collection Modal
 */
$('#collectionContainer a').on('click', function (e) {

    var value = $(this).attr("href")
    if (value == '#collectionModal') {
        e.preventDefault()
        $('#collectionModal').modal('show')
    }

})

/**
 * Modify margin for fixed header size and set CSS variables for layout calculations
 */
function updateLayoutHeights() {
    var headerHeight = $('.fixed-header').outerHeight();
    var contentPlacement = $('.fixed-header').position().top + headerHeight;
    document.documentElement.style.setProperty('--header-height', headerHeight + 'px');

    $('.content').css('padding-top', contentPlacement);

    var $bookingBar = $('.section-booking-bar');

    if ($bookingBar.length && !$bookingBar.hasClass('is-floating')) {
        var bookingBarHeight = $bookingBar.outerHeight();
        var isMobile = window.innerWidth < 768;

        document.documentElement.style.setProperty('--booking-bar-height', bookingBarHeight + 'px');

        if (isMobile) {
            document.documentElement.style.setProperty('--booking-bar-offset', '0px');
        } else {
            document.documentElement.style.setProperty('--booking-bar-offset', bookingBarHeight + 'px');
        }

        $('body').addClass('has-booking-bar');
    } else {
        document.documentElement.style.setProperty('--booking-bar-height', '0px');
        document.documentElement.style.setProperty('--booking-bar-offset', '0px');
        $('body').removeClass('has-booking-bar');
    }
}

updateLayoutHeights();

// Throttle function to limit how often a function can be called
function throttle(func, limit) {
    var inThrottle;
    return function () {
        var args = arguments;
        var context = this;
        if (!inThrottle) {
            func.apply(context, args);
            inThrottle = true;
            setTimeout(function () {
                inThrottle = false;
            }, limit);
        }
    };
}

var throttledUpdateLayout = throttle(updateLayoutHeights, 100);

$(window).on('resize', throttledUpdateLayout);
$(window).on('scroll', throttledUpdateLayout);

var layoutObserver = new MutationObserver(function () { updateLayoutHeights(); });

// Observe the fixed header and booking bar for changes
var observeConfig = { childList: true, subtree: true, attributes: true };
var $fixedHeader = $('.fixed-header');
var $bookingBar = $('.section-booking-bar');

if ($fixedHeader.length) {
    layoutObserver.observe($fixedHeader[0], observeConfig);
}

if ($bookingBar.length) {
    layoutObserver.observe($bookingBar[0], observeConfig);
}

$(window).on('load', updateLayoutHeights);

/**
 * UTM Params
 */
$('.globalTel, .globalTelMobile').on("click", function () {
    var uri = new URI(window.location.href)

    if (uri.segment(0) == 'eden-hall') {
        dataLayer.push({
            'event': 'generate_lead',
            'lead_type': 'lead_contact',
            'venue': 'Eden Hall'
        });
    } else if (uri.segment(0) == 'hoar-cross-hall') {
        dataLayer.push({
            'event': 'generate_lead',
            'lead_type': 'lead_contact',
            'venue': 'Hoar Cross Hall'
        });
    } else {
        dataLayer.push({
            'event': 'generate_lead',
            'lead_type': 'lead_contact',
            'venue': 'Barons Eden'
        });
    }

});

/**
 * Rellax
 */
import Rellax from 'rellax';
var rellax = new Rellax('.rellax');

/**
 *  slider
 */
require('../../node_modules/slick-carousel/slick/slick.js')

$('.slick').slick({
    infinite: true,
    speed: 1000,
    autoplaySpeed: 8000,
    fade: true,
    cssEase: 'linear',
    autoplay: true,
    arrows: false,
    pauseOnHover: false
});

// Initialize Slick
$('.slickInit').slick()

$('.slickInitAwards').slick({
    dots: true,
    arrows: false,
    infinite: true,
    speed: 500,
    autoplaySpeed: 1000,
    autoplay: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 580,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
    ]
});

/**
 *  Masonry
 */
require('../../node_modules/masonry-layout/dist/masonry.pkgd.min');
require('../../node_modules/imagesloaded/imagesloaded.pkgd.min');

var grid = $('.masonry').masonry({
    // options...
    itemSelector: 'li',
    columnWidth: 'li',
    percentPosition: true
});

// layout Masonry after each image loads
grid.imagesLoaded().progress(function () {
    grid.masonry('layout');
});

// image modal
// $('.masonry-item').on('click', function () {
//     var imageSrc = $(this).find('img').attr('src');
//     $('.js-modal-image').attr('src', imageSrc);

//     $('#galleryModal').modal('show')
// });



/**
 * Recaptcha
 */
window.getRecaptchaToken = function () {
    return new Promise(function (resolve, reject) {
        grecaptcha.ready(function () {
            grecaptcha.execute('6Lf__NsUAAAAADnX0QU6l3yK21j-n1thZzHqQXnt', { action: 'subscribe' }).then(function (token) {
                resolve(token)
            });
        });
    });
}
